module.exports = __webpack_public_path__ + "img/tour-52.91dcc1f1.png";